import React, { useRef, useEffect } from 'react';
import { useChat } from '../../contexts/ChatContext';
import ChatMessage from './ChatMessage';
import './ChatMessages.css';

const ChatMessages = () => {
  const { 
    getMessagesForCurrentTab, 
    currentTab,
    userSpeechBuffer,
    aiSpeechBuffer,
//    MESSAGE_TYPES
  } = useChat();
  
  const messagesEndRef = useRef(null);
  const messages = getMessagesForCurrentTab();

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, userSpeechBuffer, aiSpeechBuffer]);

  // Show streaming buffers if they have content
  const showUserStreaming = userSpeechBuffer.trim() && currentTab === 'user_speech';
  const showAIStreaming = aiSpeechBuffer.trim() && currentTab === 'ai_speech';

  return (
    <div className="chat-messages">
      <div className="messages-container">
        {messages.map(message => (
          <ChatMessage key={message.id} message={message} />
        ))}
        
        {/* Show streaming buffers */}
        {showUserStreaming && (
          <div className="message streaming user-streaming">
            <div className="message-content">
              <span className="streaming-indicator">Speaking...</span>
              <span className="streaming-text">{userSpeechBuffer}</span>
            </div>
          </div>
        )}
        
        {showAIStreaming && (
          <div className="message streaming ai-streaming">
            <div className="message-content">
              <span className="streaming-indicator">Responding...</span>
              <span className="streaming-text">{aiSpeechBuffer}</span>
            </div>
          </div>
        )}
        
        <div ref={messagesEndRef} />
      </div>
      
      {messages.length === 0 && !showUserStreaming && !showAIStreaming && (
        <div className="empty-state">
          <div className="empty-icon">●</div>
          <div className="empty-text">
            {currentTab === 'general' && 'No messages yet. Start talking to see the conversation!'}
            {currentTab === 'user_speech' && 'No user speech messages yet.'}
            {currentTab === 'ai_speech' && 'No AI speech messages yet.'}
            {currentTab === 'ai_intent' && 'No AI intents yet.'}
            {currentTab === 'system' && 'No system messages yet.'}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatMessages; 